import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

interface FooterLink {
  label: string;
  href: string;
}

interface SocialLink {
  icon: string;
  href: string;
  ariaLabel: string;
}

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  protected readonly currentYear = new Date().getFullYear();
  protected readonly brandName = 'Clúster TIC Galicia';

  protected readonly legalLinks: FooterLink[] = [
    { label: 'footer.legal.privacy', href: '#' },
    { label: 'footer.legal.terms', href: '#' },
    { label: 'footer.legal.cookies', href: '#' }
  ];

  protected readonly socialLinks: SocialLink[] = [
    { icon: '/RRSS-X.svg', href: 'https://x.com/#!/clusterticgal', ariaLabel: 'X (Twitter)' },
    { icon: '/RRSS-linkedin.svg', href: 'https://www.linkedin.com/company/cluster-tic-galicia/', ariaLabel: 'LinkedIn' },
    { icon: '/RRSS-facebook.svg', href: 'https://www.facebook.com/pages/Cluster-TIC-Galicia/128521810614161', ariaLabel: 'Facebook' }
  ];

  protected trackByLabel(_index: number, item: FooterLink): string {
    return item.label;
  }

  protected trackByIcon(_index: number, item: SocialLink): string {
    return item.icon;
  }
}
